import { Deserializable } from '../deserializable';
import { ValidationErrors } from '../validation/validation-errors';

export class FileDto implements Deserializable {
  public FileName: string;
  public ValidationErrors: ValidationErrors;

  constructor(fileName?: string) {
    this.FileName = fileName;
  }

  public deserialize(input: any): this {
    Object.assign(this, input);

    if (input.ValidationResult) {
      this.ValidationErrors = new ValidationErrors({
        BusinessValidationErrors: input.ValidationResult,
        FullValidationErrors: input.ValidationResult
      });
    }

    return this;
  }
}
